export const ArtworkPrintingTechniqueIDLabelFormatter = (printingTechnique:any, onlyPrintingTechCode=false):string|null => {
  const {decoration_technique, id, name, deco_tech_id
  } = printingTechnique;

  if(!decoration_technique?.id && !id && !name){
    return null
  }

  if(onlyPrintingTechCode){
    return `${id.toString().padStart(5, "0")} - ${name}`
  }

  if(deco_tech_id){
    return `${deco_tech_id.padStart(2, "0")}-${id.toString().padStart(5, "0")} - ${name}`
  }


  return `${decoration_technique?.id.toString().padStart(2, "0")}-${id.toString().padStart(5, "0")} - ${name}`
}